<template>
  <!-- 13-1 医疗机构收藏人才查看列表 -->
  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{ $t("favoriteTalent") }}</div>
    <div class="main-box">
      <!-- table部分 -->
      <el-row>
        <el-button type="primary" @click="deleteClick"
          >- お気に入りから削除</el-button
        >
      </el-row>
      <div class="table">
        <el-table
          @row-click="qaq"
          :data="tableData"
          :height="tableHeight"
          @sort-change="changeTableSort"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <!-- ----------------------人材番号---------------------- -->
          <el-table-column
            prop="number"
            label="人材番号"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("talentNumber") }}</p>
              <el-input
                v-model="searchData1"
                size="mini"
                clearable
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.resumeId }}
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column prop="name" label="氏名" width="120">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                clearable
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <!-- ---------------------性别-------------------- -->
          <el-table-column prop="sex" label="性别" width="80">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("sex") }}</p>
              <el-dropdown @command="handleCommandSex">
                <span class="el-dropdown-link">
                  {{ opSex }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in sexValue"
                    :key="item.code"
                    :command="item"
                  >
                    {{ item.name }}
                  </el-dropdown-item>
                  <el-dropdown-item :command="null">
                    {{ "ALL" }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'JP'">{{
                scope.row.jpsex_dictText
              }}</span>
              <span v-else>{{ scope.row.sex_dictText }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------生年月日---------------------- -->
          <el-table-column prop="birthday" label="生年月日" width="110">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("birth") }}</p>
              <el-date-picker
                v-model="searchData3"
                class="table-date"
                type="date"
                size="small"
                @change="FuzzyQuery"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :placeholder="$t('registerDayselsect')"
              >
              </el-date-picker>
            </template>
            <template slot-scope="scope">
              {{ scope.row.birth.split(" ")[0] }}
            </template>
          </el-table-column>
          <!-- ----------------------学歴---------------------- -->
          <el-table-column
            prop="background"
            label="学歴"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("educationalBackgroundMatter") }}</p>
              <div class="el-dropdown-css-2">
                <el-dropdown @command="handleCommandeducation">
                  <span class="el-dropdown-link">
                    {{ education === "" ? "All" : education
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in educationData"
                      :key="item.code"
                      :command="item"
                      >{{ item.name }}</el-dropdown-item
                    >
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              {{
                language === "CN"
                  ? scope.row.education_dictText
                  : scope.row.jpeducation_dictText
              }}
            </template>
          </el-table-column>
          <!-- ----------------------専攻---------------------- -->
          <el-table-column
            prop="major"
            label="専攻"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("major") }}</p>
              <el-input
                v-model="searchData5"
                size="mini"
                clearable
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.profession }}
            </template>
          </el-table-column>

          <!-- ----------------------日本語---------------------- -->
          <el-table-column
            prop="jp"
            label="日本語"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("japaneseVs") }}</p>
              <div class="el-dropdown-css-3">
                <el-dropdown @command="handleCommandJapanese">
                  <span class="el-dropdown-link">
                    {{ jp === "" ? "All" : jp }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      v-for="(item, index) in jpdate"
                      :key="item.code"
                      :command="item"
                      >{{ item.name }}</el-dropdown-item
                    >
                    <el-dropdown-item command="del">{{
                      $t("cancel")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
            <template slot-scope="scope">
              {{
                language === "CN"
                  ? scope.row.japanese_dictText
                  : scope.row.jpjapanese_dictText
              }}
            </template>
          </el-table-column>
          <!-- ----------------------学校---------------------- -->
          <el-table-column
            prop="school"
            label="学校"
            min-width="120"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("school") }}</p>
              <el-input
                v-model="searchData7"
                size="mini"
                clearable
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.school }}
            </template>
          </el-table-column>
          <!-- ------------------------観覧回数------------------------ -->
          <el-table-column
            prop="pageviews"
            label="観覧回数"
            :sortable="'custom'"
            width="130"
          >
            <template slot="header">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.visitedTime }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="toal"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  queryMedicalCollectionApplyjob,
  queryMedicalCollectionPerson,
  deleteMedicalCollectionPerson,
  queryFuzzyMedicalCollectionPerson
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "medicalStaffManagement",
  components: {},
  data() {
    return {
      inputData1: "", //搜索框input内容
      tableData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "", //表格第5个搜索
      searchData6: "", //表格第6个搜索
      searchData7: "", //表格第7个搜索
      searchData8: "", //表格第8个搜索
      searchData9: "", //表格第9个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",

      education: "",
      educationId: "",
      educationCode: "",
      educationData: [],
      jpCode: "",
      jp: "ALL",
      jpdate: [],
      language: "",
      sex: "",
      opSex: "ALL",
      sexValue: [],
      toal: 0,
      idList: [],
      tableHeight: "" //表格高度
    };
  },
  created() {
    this.language = window.localStorage.getItem("language");
    this.select();
    this.sexs();
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.getTableHeight();
    this.geteducation();
    this.getJapanese();
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  computed: {},
  methods: {
    //获取表格高度
    getTableHeight() {
      let tableH = 350; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        that.sexs();
        that.FuzzyQuery();
        that.geteducation();
        that.getJapanese();
      }
    },
    FuzzyQuery() {
      var dto = {
        birth: this.searchData3,
        education: this.educationCode,
        japanese: this.jpCode,
        name: this.searchData2,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        profession: this.searchData5,
        resumeId: this.searchData1,
        school: this.searchData7,
        sex: this.sex
      };
      queryFuzzyMedicalCollectionPerson(dto)
        .then(res => {
          console.log("-----医疗机构收藏人才模糊查询-----");
          console.log(res);
          if (res.data.code == "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
          } else {
            this.$message.error("查询失败。");
          }
        })
        .catch(res => {});
    },
    //医疗机构取消收藏教育机构
    deleteClick() {
      console.log("- お気に入りから削除 button");
      if (this.idList.length < 1) {
        this.$message({
          message: "请选择至少一条信息!",
          type: "warning"
        });
      } else {
        const fakeInfo = {
          collectId: this.idList
        };
        deleteMedicalCollectionPerson(fakeInfo)
          .then(res => {
            console.log("-----医疗机构取消收藏教育机构-----");
            console.log(res);
            if (res.data.code === "A0000") {
              this.$message({
                message: "取消收藏成功!",
                type: "success"
              });
              this.select();
            } else {
              this.$message.error("取消收藏失败");
            }
          })
          .catch(res => {
            console.log("-----医疗机构取消收藏教育机构-----");
            console.log(res);
          });
      }
    },
    //获取education下拉
    handleCommandeducation(evt) {
      if (evt === "del") {
        this.educationCode = "";
        this.education = "";
      } else {
        this.educationCode = evt.code;
        this.education = evt.name;
      }
      this.FuzzyQuery();
    },
    //性别筛选
    handleCommandSex(e) {
      console.log(e);
      if (e == null) {
        this.sex = "";
        this.opSex = "All";
        console.log(e);
      } else {
        this.sex = e.code;
        this.opSex = e.name;
      }
      console.log(this.sex);
      this.FuzzyQuery();
    },
    sexs() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jpsex";
      } else {
        dataItems = "sex";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.sexValue = aesFecInfo.data;
            console.log(that.sexValue);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //查询医疗机构人才
    select() {
      var dto = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      queryMedicalCollectionPerson(dto)
        .then(res => {
          console.log("查询医疗机构人才");
          if (res.data.code === "A0000") {
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            this.tableData = aesFecInfo.data;
            console.log(this.tableData);
            this.toal = aesFecInfo.total;
          } else if (res.data.code ===10001) {

       // this.$message.error("查询成功");
       window.location.href="#/userFailure";
     }else {
            console.log(res);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //性别筛选
    handleClick(val) {
      if (val === "man") {
        console.log("男");
      } else {
        console.log("女");
      }
    },
    //复选框
    handleSelectionChange(val) {
      console.log(val);
      this.idList = [];
      for (var i = 0; i < val.length; i++) {
        this.idList.push(val[i].collectId);
      }
      this.stateChange = val;
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "pageviews") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["pageviews"] - b["pageviews"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["pageviews"] - a["pageviews"]
          );
        }
      }
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.select();
      console.log(`当前页: ${val}`);
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.select();
    },
    //跳转页面
    qaq(row, event, column) {
      console.log(row);
      this.$router.push({
        name: "medicalInstitutionTalentInformationViewPublic",
        params: { resumeId: row.resumeId }
      });
      console.log(row);
    },
    aClick() {
      //第一个按钮
      //deleteMedicalCollectionPerson
    },
    geteducation() {
      var that = this;
      var dataItems = "";
      console.log(that.language);
      if (that.language === "JP") {
        dataItems = "jpeducation";
      } else {
        dataItems = "education";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据education--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.educationData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.educationData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getJapanese() {
      var that = this;
      var dataItems = "";
      if (that.language === "JP") {
        dataItems = "jpjapanese";
      } else {
        dataItems = "japanese";
      }
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: dataItems
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据sex--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.jpdate = aesFecInfo.data;
            console.log(that.jpdate);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    handleCommandJapanese(evt) {
      if (evt === "del") {
        this.jpCode = "";
        this.jp = "";
      } else {
        this.jpCode = evt.code;
        this.jp = evt.name;
      }
      console.log(evt);
      this.FuzzyQuery();
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
}
.main-box {
  margin-top: 20px;
  width: 100%;
  height: 80%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  margin-top: 20px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
}
.operate {
  height: 48px;
}
.table /deep/ .el-dropdown {
  width: 100px;
}
.table /deep/ .el-input__prefix {
  display: none;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
}
/* .table /deep/ .is-sortable> .cell {
   display: flex;
  } */
.table /deep/ .caret-wrapper {
  /* margin-top: -5px; */
  display: inline-block;
  position: absolute;
  top: -5px;
  right: 0;
  width: 67px;
}
.staff-application {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}
.manager-application {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #fc630c;
  cursor: pointer;
}
.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.pagination-main {
  float: right;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #6b5656; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 4; /*行间距*/
}
.myButton-changlimit {
  background-color: #f56c6c;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: Arial;
  font-size: 6px;
  padding: 6px 11px;
  text-decoration: none;
}

.myButton-changlimit2 {
  background-color: #409eff;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: Arial;
  font-size: 6px;
  padding: 6px 11px;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalInstitutionCollectionTalentsViewList/index.vue